import React from 'react';
import TextInput from './TextInput';
import './textInput.scss';

/** @extends TextInput */
class TextAreaInput extends TextInput {
  static defaultProps = {
    onBlur: () => {},
    label: ''
  };

  getClassNames() {
    return [
      'text-area-input',
      this.state.value !== '' ? 'has-value' : '',
      this.props.disabled ? 'read-only' : '',
      this.props.className || ''
    ].join(' ').trim();
  }

  renderLabel() {
    return this.props.label ? <label className='text-input__label'>{this.props.label}</label> : null;
  }

  render() {
    return (
      <div className='text-input__wrapper'>
        {this.renderLabel()}
        <textarea
          name={this.props.name}
          className={this.getClassNames()}
          placeholder={this.props.placeholder}
          onChange={this.handleChange}
          disabled={this.props.disabled}
          ref={this.props.inputRef}
          value={this.state.value}
        />
      </div>
    );
  }
}

export default TextAreaInput;
